import React, { useEffect, useRef, useState } from 'react';
import { Button, Header, Icon, Input, Pagination, Table, Modal } from 'react-frontier2';
import { SetLoading } from '@arema/components/Classes';
import { PdvCorte } from '../AdminClasses'
import { addCommas } from '@arema/components/Util';
import API from '../API';
import moment from 'moment';

// default search and select a venue
interface SearchModalProps {
	open: boolean,
	onClose: ()=>void,
	title?: string,
	pageSize?: number,
	pdvId: number,
	cashOnly?: boolean,
	onCorteSelected?: (corte: PdvCorte)=>void;
}

var SearchCorteModal = (props: SearchModalProps)=>{
	var [searching, setSearching] = useState<boolean>(false);
	var [searchInput, setSearchInput] = useState<string>('');
	var [searchError, setSearchError] = useState<string>(null);
	var [sentQuery, setSentQuery] = useState<string>(null);
	var [shownPdv, setShownPdv] = useState<number>(null);
	var [cortes, setCortes] = useState<PdvCorte[]>(null);
	var [page, setPage] = useState<number>(0);
	var inputRef = useRef<HTMLInputElement>(null);
	const PAGE_SIZE = (props.pageSize || 10);

	useEffect(()=>{
		if(props.open){
			if(props.pdvId && props.pdvId!=shownPdv){
				searchCortes(null, page);
			}
		}
	}, [props.open, props.pdvId]);

	var searchCortes = (setLoading: SetLoading, page?: number)=>{
		if(searching) return;
		setSearching(true);
		setSentQuery(searchInput);
		setPage(page || 0);
		setSearchError(null);
		
		API.getPdvConciliaCortes(props.pdvId, searchInput, props.cashOnly===true, page * PAGE_SIZE, PAGE_SIZE).then(res=>{
			if(res.error) return setSearchError(res.message);
			setShownPdv(props.pdvId);
			setCortes(res.data);
		}).catch(err=>{
			setSearchError('Error inesperado cargando los cortes (LCL-1)');
		}).finally(()=>{
			setSearching(false);
		});
	}

	var corteSelected = (c: PdvCorte)=>{
		return ()=>{
			if(props.onCorteSelected){
				props.onCorteSelected(c);
			}
		}
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		searchCortes(null, page);
	}

	var hasPagination = (((cortes && cortes?.length) || 0) >= PAGE_SIZE) || page !== 0;
	var hasNext = cortes?.length >= PAGE_SIZE;
	return <Modal open={props.open} onClose={props.onClose} size='small'>
		<Modal.Header>{props.title || 'Seleccionar Cortes'}</Modal.Header>
		<Modal.Content>
			<Input
				ref={inputRef}
				value={searchInput}
				onChange={setSearchInput}
				placeholder='Buscar corte por ID'
				buttons={(<Button text='Buscar' onClick={searchCortes} loading={searching} />)}
				onSubmit={searchCortes}
				iconName='search'
			/>
			<div style={{ marginTop: 5, color: 'gray', textAlign: 'center' }}>
				Mostrando solo cortes con venta en efectivo
			</div>
			{(searching || !cortes) ? (
				<Header loading text={`Buscando cortes`} style={{ marginBottom: 50, marginTop: 50 }} />
			) : searchError ? (
				<Header text='Error' subtext={searchError} iconName='face-frown-open' style={{ marginTop: 30, marginBottom: 30 }} size='small' />
			) : cortes?.length === 0 ? (
				<Header text='No se encontraron cortes' subtext={`No se encontraron cortes con el id "${sentQuery}"`} iconName='face-frown-open' style={{ marginTop: 30, marginBottom: 30 }} size='small' />
			) : (
				<Table fitted selectable style={{ marginTop: 10 }} className='top'>
					<Table.Head
						data={[['ID', 'Fecha', 'Ventas', (props.cashOnly ? 'Efectivo' : 'Ingresos'), 'Depositado', 'Restante']]}
						collapsingIndexes={[0, 2, 3, 4, 5]}
					/>
					<Table.Body>
						{cortes.length===0 && (
							<Table.Cell empty row colSpan={100} value='No se encontraron cortes para este punto de venta' />
						)}
						{cortes.map(c=>(
							<Table.Row
								collapsingIndexes={[0, 2, 3, 4, 5]}
								centeredIndexes={[2]}
								key={`SRCHMD-${c.corte_id}`}
								onClick={corteSelected(c)}
								style={((props.cashOnly ? c.total_cash : c.total)-c.deposit)<=0 ? { color: 'gray' } : null}
								data={[
									c.corte_id,
									moment.unix(c.date_start).format('DD/MM/YY HH:mm:ss'),
									c.order_count,
									// `$${addCommas(c.total)}`,
									`$${addCommas(props.cashOnly ? c.total_cash : c.total)}`,
									`$${addCommas(c.deposit)}`,
									props.cashOnly ? (
										`$${addCommas(c.total_cash-c.deposit)}`
									) : <Icon name='minus' color='gray' />
								]}
							/>
						))}
					</Table.Body>
					{hasPagination && (
						<Table.Footer>
							<Table.Cell row colSpan={7}>
								<div style={{ justifyContent: 'flex-end', display: 'flex' }}>
									<Pagination page={page} disabled={searching} onPageChange={onPageChange} hasNext={hasNext} />
								</div>
							</Table.Cell>
						</Table.Footer>
					)}
				</Table>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' onClick={props.onClose} color='black' />
		</Modal.Actions>
	</Modal>
}

export default SearchCorteModal;